import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    className?: string
}

const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <svg viewBox='0 0 32 32' className='size-7' aria-hidden='true'>
                <circle cx='16' cy='16' r='11' fill='none' stroke='#a78bfa' strokeOpacity='0.55' strokeWidth='1.5' />
                <circle cx='16' cy='16' r='4.5' fill='#a78bfa' />
                <circle cx='16' cy='5' r='2.5' fill='#e879f9' />
                <circle cx='27' cy='16' r='2.5' fill='#22d3ee' />
                <circle cx='16' cy='27' r='2.5' fill='#fbbf24' />
                <circle cx='5' cy='16' r='2.5' fill='#34d399' />
            </svg>

            <span className='font-heading text-lg font-semibold tracking-tight'>
                {siteConfig.name}
            </span>
        </span>
    )
}

export default Logo
